module.exports = __webpack_public_path__ + "img/ai-user.dda76df6.svg";